import React from 'react';
import { useBank } from '../../hooks/useBank';
import { useInventory } from '../../hooks/useInventory';
import { DevConfig } from '../../../../config/environment/devConfig';
import { BankView } from './bank/BankView';

/**
 * BankContent — the `bank` window body, propless. WindowHost mounts it inside
 * the Tome frame; it wires the authoritative bank (useBank) and the bag
 * (useInventory) into the presentational BankView (bank/BankView.tsx).
 */
export const BankContent: React.FC = () => {
  const bank = useBank();
  const { items, gold, maxSlots } = useInventory();
  return <BankView bank={bank} inventory={{ items, gold, maxSlots }}
    showTestGear={DevConfig.systems.debugToolbox} />;
};
